import isMobile from '../src/utils/isMobile';

export default function columnFormatter(name) {
  return isMobile() ? name : name.toUpperCase();
}
